import React, { Fragment } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";
import { connect } from "react-redux";

import AdminDashboardContent from "./AdminDashboardContent";
import DashboardChart from "./DashboardChart";

const AdminDashboard = ({ auth: { loading } }) => {
  return (
    <Fragment>
      <div id="wrapper" style={{ marginBottom: "30px" }}>
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header />
            <div className="container-fluid">
              <AdminDashboardContent />
              <DashboardChart />
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </Fragment>
  );
};
const mapStateToProps = (state) => ({
  auth: state.auth,
});
export default connect(mapStateToProps)(AdminDashboard);
